import * as React from 'react';

import {colors} from '../../colors/colors';
import {UpgradeArrowIconNewNav} from '../../icon/svg/upgrade-arrow-icon-new-nav';
import {Body} from '../../typography/body';

import styles from './usage-footer-upgrade-button.module.css';

type Props = {
    onClick: () => void;
};

export function UsageFooterUpgradeButton(props: Props) {
    return (
        <button onClick={props.onClick} className={styles['upgrade-button']}>
            <Body color='white' size='mini'>
                Upgrade plan
            </Body>
            {/* @ts-expect-error */}
            <UpgradeArrowIconNewNav size={14} color={colors.blue} wrapWithDiv={false} />
        </button>
    );
}
